if (!customElements.get('ticker-bar')) {
  // Guarded: this section's markup includes this same script tag once per
  // instance on the page (e.g. the site-wide top bar + a homepage marquee
  // instance both render it), so it can load more than once per page load.
  class TickerBar extends HTMLElement {
    connectedCallback() {
      const prevBtn = this.querySelector('.jp-ticker__arrow--prev');
      const nextBtn = this.querySelector('.jp-ticker__arrow--next');
      if (!prevBtn && !nextBtn) return; // marquee mode — no arrow navigation needed

      this.items = Array.from(this.querySelectorAll('.jp-ticker__item'));
      if (this.items.length < 2) return;

      this.index = this.items.findIndex((item) => item.classList.contains('is-active'));
      if (this.index === -1) this.index = 0;

      prevBtn?.addEventListener('click', () => this.show(this.index - 1));
      nextBtn?.addEventListener('click', () => this.show(this.index + 1));
    }

    show(index) {
      const count = this.items.length;
      this.index = (index + count) % count;
      this.items.forEach((item, i) => item.classList.toggle('is-active', i === this.index));
    }
  }

  customElements.define('ticker-bar', TickerBar);
}
